export const deleteFilterHandler = (
  deleteValue,
  deleteIndex,
  setSelectedContents,
  formik,
  setUpdate,
  setPage,
  fromKanban,
  setIsClearAll
) => {
  setIsClearAll(true);

  setSelectedContents((prev) =>
    prev.filter((_, index) => index !== deleteIndex)
  );

  const fieldMap = {
    "Accession number": { accession_number: "" },
    Category: {
      category_id: "",
      selectedCategory: "",
      primary_category: "",
      selctedSubCategory: [],
    },
    Materials: { material_id: "", selectedMaterial: [] },
    Room: { room: "", selectedRoom: "" },
    Height: { height_min: "", height_max: "" },
    Width: { width_min: "", width_max: "" },
    Depth: { depth_min: "", depth_max: "" },
    "Datable time period": { period_start: "", period_end: "", period: "" },
    "Acquisition method": { acquisition_method: "" },
    "Created date": { start_date: "", end_date: "", selectedDate: [] },
    "Original location": { room: "", selectedRoom: "" },
    "Transit location": { transit_room: [], selectedTransitRoom: [] },
    "Created by": { created_by: "", selectedUser: "" },
    "Reference image": { is_image: "", hasImage: false, hasNoImage: false },
    "Iconic object": { is_iconic: "", hasIconic: false, hasNoIconic: false },
    Tags: { tags: "" },
    "Last updated": {
      modified_end_date: "",
      modified_start_date: "",
      selectedUpdateDate: [],
    },
    "Condition grading": { conservation_grade: "", is_emergency: false },
    "Assigned to me": { object_assigned: "" },
    Remark: { remarks: "", hasRemark: false, hasNoRemark: false },
  };

  if (fieldMap[deleteValue?.title]) {
    formik.setValues({
      ...formik.values,
      ...fieldMap[deleteValue.title],
    });
  }
  if (!fromKanban) {
    setPage(1);
  }
  setUpdate((prev) => !prev);
};
